export class Utils {

  public static getPlayerInitials(name: string) {
    const nameArr = name.split(' ');
    if (nameArr.length > 1) {
      return `${nameArr[0][0]}${nameArr[1][0]}`;
    } else if (nameArr.length) {
      return nameArr[0][0];
    } else {
      return '-';
    }
  }
  public static getPlayerShortName(name: string) {
    const nameArr = name.split(' ');
    if (name === 'Rudy Fernández') {
      return 'Rudy';
    } else {
      if (nameArr.length === 1) {
        return `${name}`;
      } else if (nameArr.length) {
        return `${nameArr.slice(1).join(' ')}`;
      } else {
        return '-';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/utils.ts